import $http from '../services/AxiosInstance';

export interface IMunicipio {
  id: number;
  municipioNombre: string;
  
}


class GeoRefSpainRepository {
  static async getMunicipios(): Promise<IMunicipio[]> {
    try {
      let url = '/spainMunicipios/municipios';

      const response = await $http.get(url);
      return response.data.map((municipio: IMunicipio) => ({
        id: municipio.id,
        nombre: municipio.municipioNombre,
      }));
    } catch (errors: any) {
      throw Error;
    }
  }
  
}

export default GeoRefSpainRepository;
